module.exports = __webpack_public_path__ + "img/AFL_logo_EN_white.41680ef3.svg";